























FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["posts", "totalPages"]
	components:
		pageTemplateProjectHeader: require "components/page/about/Header"
		secondaryNav: require "components/common/secondaryNav"
		postLink: require "./posts/postLink"
		publicationLink: require "./publications/postLink"
		newsLink: require "./news/postLink"
		pagenation: require "./pagenation"
		spinner: require "components/common/spinner"
	computed:
		pageName: -> return this.$route.name.replace("en_","")
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		projectName: -> return this.$route.params.projectName
		toAbout: ->
			name = if !this.isEnglish then "about" else "en_about"
			return {name: name, params: {projectName: this.projectName}}
	methods:
		renderText: (strJa, strEn) -> return if !this.isEnglish then strJa else strEn



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/archiveTemplate.vue